import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router';
import {RootState, actionCreator} from '../_modules';
import {Handlers, Store, State} from './types';
import View from './view';


const Describe: React.FC = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState<State>({
    query: '',
  });
  const location = useLocation();

  const store: Store = useSelector((rootState: RootState): Store => {
    const key = rootState.activeArticleId;
    const result = key !== undefined ?
      rootState.searchResults[key] :
      undefined;
    return {
      result,
      activeLocation: rootState.activeLocation,
      articleKey: key,
    };
  });

  const handlers: Handlers = {
    handleClickWord: (text) => {
      dispatch(actionCreator.setActiveLocation({key: text}));
    },
    close: () => dispatch(actionCreator.setActiveArticle({key: undefined})),
    focus: () => {
      if (store.result === undefined) {
        return;
      }
      const lngSet = store.result.geojson.map((each) => each.geometry.coordinates[0]);
      const latSet = store.result.geojson.map((each) => each.geometry.coordinates[1]);
      const minLng = Math.min(...lngSet);
      const minLat = Math.min(...latSet);
      const maxLng = Math.max(...lngSet);
      const maxLat = Math.max(...latSet);
      dispatch(actionCreator.setMapBounds({maxLngLat: [maxLng, maxLat], minLngLat: [minLng, minLat]}));
    },
  };

  /* get search query */
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const query = urlParams.get('q') || '';
    setState({...state, query});
  }, [location.search]);

  return <View {...{handlers, store, state}}/>;
};

export default Describe;
